import axios from "../../../services/axios-config.js";

export function getUsers() {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await axios.get('/admin/users');
            if (res.status === 200) return resolve(res.data);
        } catch (e) {
            console.error('ERROR - GET USERS FUNCTION:', e);
            reject(e);
        }
    });
}
